import { render, staticRenderFns } from "./tournaments-skeleton.vue?vue&type=template&id=498deaf1&scoped=true&"
import script from "./tournaments-skeleton.vue?vue&type=script&lang=js&"
export * from "./tournaments-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./tournaments-skeleton.vue?vue&type=style&index=0&id=498deaf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498deaf1",
  null
  
)

export default component.exports